<template>
  <el-select
    v-model="country"
    class="phone-initial-country"
    filterable
    clearable
    :placeholder="
      $t('element.property.form.field.phone.initial_country.placeholder')
    "
    @change="onCountryChange"
  >
    <el-option
      v-for="item in countries"
      :key="item.alpha2"
      :label="item.name"
      :value="item.alpha2.toLowerCase()"
    />
  </el-select>
</template>

<script>
import * as _ from 'lodash'
import cdn from '@/js/store/services/cdn'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      countries: [],
      country: this.normalize(this.value),
    }
  },
  watch: {
    value(next) {
      this.country = this.normalize(next)
    },
  },
  async mounted() {
    const countries = await cdn.countries()
    this.countries = _.sortBy(
      countries.filter((item) => item && item.alpha2 && item.name),
      'name',
    )
  },
  methods: {
    normalize(code) {
      if (typeof code !== 'string') return ''
      const value = code.trim().toLowerCase()
      return /^[a-z]{2}$/.test(value) ? value : ''
    },
    onCountryChange(alpha2) {
      this.$emit('change', this.normalize(alpha2))
    },
  },
}
</script>

<style scoped>
.phone-initial-country {
  width: 100%;
}
</style>
